'use es6';

export const MessageTypes = {
  JSON: 'json',
  RAW: 'raw',
  ERROR: 'error',
  API_REQUEST: 'api-request',
  API_RESPONSE: 'api-response'
};